import { combineReducers } from 'redux';
import chartsPage from '../../pages/ProjectsPage/reducers/projectsPageReducer.js';
import customiseEditorPage from '../../pages/CustomiseEditorPage/reducers/customiseEditorPageReducer.js';
import settingsPage from '../../pages/SettingsPage/reducers/settingsPageReducer';
import teamMembersPage from '../../pages/TeamMembersPage/reducers/teamMembersPageReducer';
import teamWebhooksPage from '../../pages/TeamWebhooksPage/reducers/teamWebhooksPageReducer';
import teamInvitationsPage from '../../pages/TeamInvitationsPage/reducers/teamInvitationsPageReducer';
import teamGroupsPage from '../../pages/TeamGroupsPage/reducers/teamGroupsPageReducer';
import apiPage from '../../pages/ApiPage/reducers/apiPageReducer';
import themesPage from '../../pages/ThemesPage/reducers/themesPageReducer';
import app from './appReducer';
import profile from './profileReducer';
import plansPage from '../../pages/PlansPage/reducers/plansPageReducer';
import billingPage from '../../pages/BillingPage/reducers/billingPageReducer';
import billingHistoryPage from '../../pages/BillingHistoryPage/reducers/billingHistoryPageReducer';
import layoutEditorPage from '../../pages/LayoutEditorPage/reducers/layoutEditorReducer';
import tableEditorPage from '../../pages/TableEditorPage/reducers/tableEditorReducer';
import showChartPage from '../../pages/ShowChartPage/reducers/showChartPageReducer';
import chartEditorPage from '../../pages/ChartEditorPage/reducers/chartEditorReducer';
import projectConfig from './projectConfigReducer';
import dataGridConfig from './dataGridReducer';

export default combineReducers({
  chartsPage,
  customiseEditorPage,
  app,
  profile,
  settingsPage,
  teamMembersPage,
  teamInvitationsPage,
  teamWebhooksPage,
  teamGroupsPage,
  apiPage,
  themesPage,
  plansPage,
  billingPage,
  billingHistoryPage,
  layoutEditorPage,
  tableEditorPage,
  showChartPage,
  chartEditorPage,
  projectConfig,
  dataGridConfig
});
